import { HOME_PAGE, PAGE_LAYOUT, BLOG_CATEGORY_PAGE, BLOG_PAGE } from '../../src/shared/pageTypes';

export const isHomePage = type => type === HOME_PAGE;

export const isBlogCategoryPage = type => type === BLOG_CATEGORY_PAGE;
export const isBlogPage = type => type === BLOG_PAGE;

export const PAGE_LAYOUT_TYPE = PAGE_LAYOUT;
